/**
 * Portal Entry Point for Employee Domain
 *
 * This file registers all pages with the portal system.
 * It is imported by the portal's virtual:portal-entries module.
 */

import { registerPage } from '@ja/portal/pageRegistry'
import { registerSidebarComponent } from '@ja/portal/sidebarComponents'

// Employee domain pages
registerPage('portal-employee', 'Profile', () => import('./pages/Profile.vue'))
registerPage('portal-employee', 'MySchedule', () => import('./pages/MySchedule.vue'))
registerPage('portal-employee', 'PunchClock', () => import('./pages/PunchClock.vue'))
registerPage('portal-employee', 'Formations', () => import('./pages/Formations.vue'))

import CoachesShortcut from './components/CoachesShortcut.vue'
registerSidebarComponent('portal-employee:CoachesShortcut', CoachesShortcut)
// Request pages render the Workforce components directly via
// `workforce-requests::Base/*` (see Workforce\Requests RequestPageController) —
// no portal-employee wrappers.

// Punch actions (lazy-loaded components, lightweight registration)
import './services/punchActionRegistrations'
